export type UnitMaterialsPrefs = {
  useWorksheets: boolean;
  readingAudience: string;
  readingDepth: string;
  includeVideos: boolean;
  minimalWordsMin: number;
  minimalWordsMax: number;
  moderateWordsMin: number;
  moderateWordsMax: number;
  comprehensiveWordsMin: number;
  comprehensiveWordsMax: number;
};

export const unitContentSources = {
  aiGenerated: 'AiGenerated',
  externalBook: 'ExternalBook',
  externalOnline: 'ExternalOnline'
} as const;

export type UnitContentSource = (typeof unitContentSources)[keyof typeof unitContentSources];

export const externalProviderKinds = {
  bookPublisher: 'BookPublisher',
  onlineProvider: 'OnlineProvider'
} as const;

export type ExternalProviderKind = (typeof externalProviderKinds)[keyof typeof externalProviderKinds];

export const lessonDeliveryModes = {
  inAppInstruction: 'InAppInstruction',
  externalResource: 'ExternalResource'
} as const;

export type ManualLessonEntry = {
  title: string;
  summary: string;
};

export type CreateUnitRequest = {
  topicIds: string[];
  unitCreationMode: 'SingleSubject' | 'Blended';
  includeApplicationLesson?: boolean;
  contentSource: UnitContentSource;
  studentId: string;
  learningStyles: string[];
  specialInstructions: string;
  materialsPrefs?: UnitMaterialsPrefs;
  externalProviderId?: string;
  manualLessonEntries?: ManualLessonEntry[];
  sourceBlobIds?: string[];
};
